export const deptList = {
  cse: 'Computer Science',
  is: 'Information Science',
  me: 'Mechanical Engineering',
  ece: 'Electronics And Communication',
  civil: 'Civil Engineering',
}

export const branchSelect = [
  { value: 'bs', name: 'BASIC' },
  { value: 'cse', name: 'CSE' },
  { value: 'is', name: 'IS' },
  { value: 'me', name: 'ME' },
  { value: 'ece', name: 'ECE' },
  { value: 'civil', name: 'CIVIL' },
]

export const semSelect = [
  { value: 3, name: '3rd Sem' },
  { value: 4, name: '4th Sem' },
  { value: 5, name: '5th Sem' },
  { value: 6, name: '6th Sem' },
  { value: 7, name: '7th Sem' },
  { value: 8, name: '8th Sem' },
]

export const basicSelect = [
  { value: 1, name: '1st Sem' },
  { value: 2, name: '2nd Sem' },
]

export const semList = [
  { name: '1st', value: 1 },
  { name: '2nd', value: 2 },
  { name: '3rd', value: 3 },
  { name: '4th', value: 4 },
  { name: '5th', value: 5 },
  { name: '6th', value: 6 },
  { name: '7th', value: 7 },
  { name: '8th', value: 8 },
]

export const branchList = [
  { name: 'CSE', value: 'cse' },
  { name: 'ISE', value: 'ise' },
  { name: 'MECH', value: 'mech' },
  { name: 'CIV', value: 'civ' },
  { name: 'ECE', value: 'ece' },
]
